var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.0002016 7.54403L56.2978 7.54402L50.1942 13.5064L50.8645 14.1612L57.7865 7.39925C57.8568 7.33062 57.9808 7.20208 58.0904 7.08729L58.0967 7.08074L58.087 7.07029C57.9771 6.95127 57.8547 6.82086 57.7865 6.75428L54.3474 3.39467L54.3317 3.39467L50.8566 -1.46258e-05L50.1863 0.654768L56.2899 6.61717L0.00651103 6.61718L0.006511 6.31718L0.0002016 7.54403Z"}));
}

ArrowInline.defaultProps = {"viewBox":"0 0 59 15"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
